import type { ReactNode } from 'react';
import React, { Fragment, useState } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Backdrop } from 'Components/frameworks/backdrop/Backdrop';
import { Image } from 'Components/frameworks/image/Image';
type Props = {
  children?: ReactNode;
  className?: string;
  closeLabel?: string;
  dataTestId?: string;
  imageSrc: string;
  onClick?: () => void;
  ratio?: {
    w: number;
    h: number;
  };
  title?: string;
};
export const Map = ({
  children,
  className,
  closeLabel,
  dataTestId,
  imageSrc,
  onClick,
  ratio = {
    w: 29,
    h: 32,
  },
  title,
}: Props) => {
  const [isOpen, setOpen] = useState(false);

  if (!imageSrc) {
    return null;
  }

  return (
    <Fragment>
      <button
        className={classnames('relative block w-full cursor-pointer overflow-hidden', className)}
        data-testid={dataTestId}
        onClick={() => {
          setOpen(true);
          !isOpen && onClick?.();
        }}
        type="button"
      >
        <Image imageUrl={imageSrc} dimensions={ratio} />
      </button>
      {isOpen && (
        <Backdrop
          ariaLabel={title}
          closeLabel={closeLabel}
          hasCloseButton
          onClose={() => setOpen(false)}
        >
          <div className="h-full flex-1">{children}</div>
        </Backdrop>
      )}
    </Fragment>
  );
};
